/**
 * 根據字串內容產生一致的隨機顏色
 * 使用簡單的 hash 函數確保相同字串永遠產生相同顏色
 */

// Ant Design Tag 預設顏色列表
const TAG_COLORS = [
  'magenta',
  'red',
  'volcano',
  'orange',
  'gold',
  'lime',
  'green',
  'cyan',
  'blue',
  'geekblue',
  'purple',
];

/**
 * 簡單的字串 hash 函數
 * @param {string} str - 輸入字串
 * @returns {number} hash 值
 */
function hashCode(str) {
  if (!str) return 0;

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

/**
 * 根據字串內容獲取一致的顏色
 * @param {string} text - 輸入字串
 * @param {Array<string>} colors - 可選的自訂顏色列表
 * @returns {string} Ant Design 顏色名稱
 */
export function getColorForText(text, colors = TAG_COLORS) {
  if (!text) return colors[0];

  const hash = hashCode(String(text));
  const index = hash % colors.length;
  return colors[index];
}

/**
 * 產生帶顏色的 Tag props
 * @param {string} text - Tag 文字內容
 * @param {Object} options - 額外選項
 * @param {Array<string>} options.colors - 自訂顏色列表
 * @param {Object} options.extraProps - 額外的 Tag props
 * @returns {Object} 包含 color 和其他 props 的物件
 */
export function getColorTagProps(text, options = {}) {
  const { colors = TAG_COLORS, extraProps = {} } = options;

  return {
    color: getColorForText(text, colors),
    ...extraProps,
  };
}

export default getColorForText;
